import {
  CarModelColorDto,
  ColorDtoDelekComponentDto,
  UpholsteryDtoDelekComponentDto,
} from "api"

export type ColorCarouselProps = CarModelColorDto & {
  additionalPrice: number
  inStock: boolean
}
// Map Colors to the shape that the ColorsCarousel expects. To retrieve colors:
export const mapDataToFitCarousel = (
  data: ColorDtoDelekComponentDto[] | UpholsteryDtoDelekComponentDto[],
  imageName
): ColorCarouselProps[] =>
  data.map((item) => ({
    name: item?.details?.name,
    hex: item?.details?.hexValue,
    colorImage: {
      imageUrl: item?.details?.[imageName]?.imageUrl,
      alt: item?.details?.colorImage?.alt,
    },
    hasAdditionalPrice: !!item?.price?.totalPrice,
    images: item?.details?.images,
    code: item?.details?.code,
    additionalPrice: item?.price?.totalPrice,
    inStock: item?.details?.inStock,
  }))
